import {
  Alert as MantineAlert,
  type AlertProps as MantineAlertProps,
} from "@mantine/core";
import type { CoreComponentProps } from "../../types";
import { useShouldRender } from "../../../hooks/useShouldRender";

export type AlertProps = CoreComponentProps<MantineAlertProps, 'div'>;

export function Alert({ testId, view = "all", ...rest }: AlertProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;
  return <MantineAlert data-testid={testId} {...rest} />;
}
